export type { LinkButtonProps } from './LinkButton.types';
export { default } from './LinkButton';
